export default __webpack_public_path__ + "static/media/03_photo.07c8279d.jpg";